// AUTO-GENERATED (gen_hero_i18n.py). Landing hero copy (badge/title/subtitle), non-FR languages.
export const HERO_GEN = {
 "en": {
  "badge": "Available in 22 languages • Built for European farmers",
  "title": "Manage your entire farm from a single platform.",
  "subtitle": "Handle your animals, production, sales, inventory, accounting, and customers from one single platform, available in 22 languages and tailored for farmers across all of Europe."
 },
 "es": {
  "badge": "Disponible en 22 idiomas • Diseñado para ganaderos europeos",
  "title": "Gestione toda su explotación desde una sola plataforma.",
  "subtitle": "Administre sus animales, producciones, ventas, inventarios, contabilidad y clientes desde una sola plataforma, disponible en 22 idiomas y adaptada para ganaderos de toda Europa."
 },
 "it": {
  "badge": "Disponibile in 22 lingue • Pensato per gli allevatori europei",
  "title": "Gestisci tutta la tua azienda agricola da un'unica piattaforma.",
  "subtitle": "Gestisci i tuoi animali, le produzioni, le vendite, le scorte, la contabilità e i clienti da un'unica piattaforma, disponibile in 22 lingue e pensata per gli allevatori di tutta Europa."
 },
 "nl": {
  "badge": "Beschikbaar in 22 talen • Ontworpen voor Europese boeren",
  "title": "Beheer uw hele boerderij vanuit één enkel platform.",
  "subtitle": "Beheer uw dieren, uw productie, uw verkoop, uw voorraden, uw boekhouding en uw klanten vanuit één enkel platform, beschikbaar in 22 talen en afgestemd op boeren uit heel Europa."
 },
 "sv": {
  "badge": "Tillgänglig på 22 språk • Utformad för europeiska lantbrukare",
  "title": "Styr hela din gård från en enda plattform.",
  "subtitle": "Hantera dina djur, din produktion, dina försäljningar, ditt lager, din bokföring och dina kunder från en enda plattform – tillgänglig på 22 språk och anpassad för lantbrukare i hela Europa."
 },
 "de": {
  "badge": "Verfügbar in 22 Sprachen • Entwickelt für europäische Landwirte",
  "title": "Steuern Sie Ihren gesamten Betrieb von einer einzigen Plattform aus.",
  "subtitle": "Verwalten Sie Ihre Tiere, Ihre Produktion, Ihren Verkauf, Ihre Lagerbestände, Ihre Buchhaltung und Ihre Kunden – alles auf einer einzigen Plattform, verfügbar in 22 Sprachen und zugeschnitten auf Landwirte in ganz Europa."
 },
 "da": {
  "badge": "Tilgængelig på 22 sprog • Designet til europæiske landmænd",
  "title": "Styr hele din bedrift fra én enkelt platform.",
  "subtitle": "Administrer dine dyr, din produktion, dit salg, dine lagre, dit regnskab og dine kunder fra én enkelt platform – tilgængelig på 22 sprog og skræddersyet til landmænd i hele Europa."
 },
 "bg": {
  "badge": "Достъпно на 22 езика • Създадено за европейски фермери",
  "title": "Управлявайте цялото си стопанство от една единствена платформа.",
  "subtitle": "Управлявайте животните си, производството, продажбите, складовите наличности, счетоводството и клиентите си от една единствена платформа, достъпна на 22 езика и адаптирана за фермери от цяла Европа."
 },
 "hr": {
  "badge": "Dostupno na 22 jezika • Dizajnirano za europske uzgajivače",
  "title": "Upravljajte cijелim svojim gospodarstvom s jedne platforme.",
  "subtitle": "Vodite evidenciju svojih životinja, proizvodnje, prodaje, zaliha, računovodstva i klijenata s jedne platforme, dostupne na 22 jezika i prilagođene uzgajivačima diljem Europe."
 },
 "et": {
  "badge": "Saadaval 22 keeles • Loodud Euroopa loomakasvatajatele",
  "title": "Juhtige kogu oma talu ühelt platvormilt.",
  "subtitle": "Hallake oma loomi, toodangut, müüki, varusid, raamatupidamist ja kliente ühelt platvormilt – saadaval 22 keeles ja kohandatud loomakasvatajatele üle kogu Euroopa."
 },
 "fi": {
  "badge": "Saatavilla 22 kielellä • Suunniteltu eurooppalaisille kasvattajille",
  "title": "Hallitse koko tilaasi yhdeltä alustalta.",
  "subtitle": "Hallitse eläimiäsi, tuotantoasi, myyntiäsi, varastojasi, kirjanpitoasi ja asiakkaitasi yhdeltä alustalta – saatavilla 22 kielellä ja suunniteltu kasvattajille kaikkialta Euroopasta."
 },
 "el": {
  "badge": "Διαθέσιμο σε 22 γλώσσες • Σχεδιασμένο για Ευρωπαίους κτηνοτρόφους",
  "title": "Διαχειριστείτε ολόκληρη την εκμετάλλευσή σας από μία μόνο πλατφόρμα.",
  "subtitle": "Διαχειριστείτε τα ζώα σας, την παραγωγή, τις πωλήσεις, τα αποθέματα, τη λογιστική και τους πελάτες σας από μία μόνο πλατφόρμα, διαθέσιμη σε 22 γλώσσες και προσαρμοσμένη στους κτηνοτρόφους σε ολόκληρη την Ευρώπη."
 },
 "hu": {
  "badge": "22 nyelven elérhető • Európai gazdálkodóknak tervezve",
  "title": "Irányítsa teljes gazdaságát egyetlen platformról.",
  "subtitle": "Kezelje állatait, termelését, értékesítését, készleteit, könyvelését és ügyfeleit egyetlen platformról – 22 nyelven elérhető, és egész Európa gazdálkodóihoz igazítva."
 },
 "pt": {
  "badge": "Disponível em 22 idiomas • Criado para criadores europeus",
  "title": "Gerencie toda a sua exploração a partir de uma única plataforma.",
  "subtitle": "Administre seus animais, produções, vendas, estoques, contabilidade e clientes a partir de uma única plataforma, disponível em 22 idiomas e adaptada para criadores de toda a Europa."
 },
 "pl": {
  "badge": "Dostępny w 22 językach • Stworzony dla europejskich hodowców",
  "title": "Zarządzaj całym gospodarstwem z jednej platformy.",
  "subtitle": "Kontroluj swoje zwierzęta, produkcję, sprzedaż, zapasy, księgowość i kontakty z klientami z jednej platformy — dostępnej w 22 językach i dostosowanej do hodowców z całej Europy."
 },
 "lt": {
  "badge": "Prieinama 22 kalbomis • Sukurta Europos ūkininkams",
  "title": "Valdykite visą savo ūkį iš vienos platformos.",
  "subtitle": "Tvarkykite savo gyvūnus, produkciją, pardavimus, atsargas, apskaitą ir klientus iš vienos platformos, prieinamos 22 kalbomis ir pritaikytos ūkininkams visoje Europoje."
 },
 "lv": {
  "badge": "Pieejams 22 valodās • Izstrādāts Eiropas lopkopjiem",
  "title": "Pārvaldiet visu savu saimniecību no vienas platformas.",
  "subtitle": "Pārvaldiet savus dzīvniekus, ražošanu, pārdošanu, krājumus, grāmatvedību un klientus no vienas platformas, kas pieejama 22 valodās un pielāgota lopkopjiem visā Eiropā."
 },
 "ro": {
  "badge": "Disponibil în 22 de limbi • Conceput pentru crescătorii europeni",
  "title": "Gestionați întreaga fermă dintr-o singură platformă.",
  "subtitle": "Administrați animalele, producțiile, vânzările, stocurile, contabilitatea și clienții dintr-o singură platformă, disponibilă în 22 de limbi și adaptată crescătorilor din toată Europa."
 },
 "sk": {
  "badge": "Dostupné v 22 jazykoch • Navrhnuté pre európskych chovateľov",
  "title": "Riaďte celý svoj podnik z jedinej platformy.",
  "subtitle": "Spravujte svoje zvieratá, produkciu, predaj, zásoby, účtovníctvo aj zákazníkov z jedinej platformy, dostupnej v 22 jazykoch a prispôsobenej chovateľom z celej Európy."
 },
 "sl": {
  "badge": "Na voljo v 22 jezikih • Ustvarjeno za evropske rejce",
  "title": "Upravljajte celotno kmetijo z ene same platforme.",
  "subtitle": "Upravljajte svoje živali, proizvodnjo, prodajo, zaloge, računovodstvo in stranke z ene same platforme, na voljo v 22 jezikih in prilagojene rejcem po vsej Evropi."
 },
 "cs": {
  "badge": "Dostupné ve 22 jazycích • Navrženo pro evropské chovatele",
  "title": "Řiďte celý svůj podnik z jediné platformy.",
  "subtitle": "Spravujte svá zvířata, produkci, prodeje, zásoby, účetnictví i zákazníky z jediné platformy, dostupné ve 22 jazycích a přizpůsobené chovatelům z celé Evropy."
 }
};
